jQuery(document).ready(function ($) {

    function preventPageUnload() {
        window.onbeforeunload = function () {
            return false;
        };
    }

    function allowPageUnload() {
        window.onbeforeunload = null;
    }

    // Detect when WooCommerce starts an AJAX request
    // This includes events such as applying or removing a coupon.
    $(document).ajaxStart(function () {
        preventPageUnload();
    });

    // Detect when WooCommerce finishes all AJAX requests
    $(document).ajaxStop(function () {
        allowPageUnload();
    });

});